import { createAction } from '@reduxjs/toolkit';

import { SET_LOADING } from '@/types/store/actions';
import { type Loading } from '@/types/store/reducers';

export const setLoading = createAction<Loading, typeof SET_LOADING>(SET_LOADING);
